/** biome-ignore-all lint/suspicious/noExplicitAny: allow any */

export const selectGuestName = ({guest, user}: any) => guest?.name || user?.userName || user?.name;
